import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'areas',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: '',
    loadComponent: () =>
      import('./shared/components/layout/layout.component').then(
        (m) => m.LayoutComponent
      ),
    children: [
      {
        path: 'areas',
        loadComponent: () =>
          import('./features/areas/areas/areas.component').then(
            (m) => m.AreasComponent
          ),
        canActivate: [authGuard],
        title: 'Areas - Smart Wash room system Kidana SWS',
      },
      {
        path: 'areas/:areaId/zones',
        loadComponent: () =>
          import('./features/zones/zones/zones.component').then(
            (m) => m.ZonesComponent
          ),
        canActivate: [authGuard],
        title: 'Zones - Smart Wash room system Kidana SWS',
      },
      {
        path: 'areas/:areaId/zones/:zoneId/blocks',
        loadComponent: () =>
          import('./features/blocks/blocks/blocks.component').then(
            (m) => m.BlocksComponent
          ),
        canActivate: [authGuard],
        title: 'Blocks - Smart Wash room system Kidana SWS',
      },
      {
        path: 'areas/:areaId/zones/:zoneId/blocks/:blockId/sub-blocks',
        loadComponent: () =>
          import('./features/sub-blocks/sub-blocks/sub-blocks.component').then(
            (m) => m.SubBlocksComponent
          ),
        canActivate: [authGuard],
        title: 'Sub Blocks - Smart Wash room system Kidana SWS',
      },
      {
        path: 'map',
        loadComponent: () =>
          import('./features/map/map/map.component').then(
            (m) => m.MapComponent
          ),
        // canActivate: [authGuard],
        title: 'Map - Smart Wash room system Kidana SWS',
      },
    ],
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./features/errors/pages/unauthorized/unauthorized.component').then(
        (m) => m.UnauthorizedComponent
      ),
    title: 'Unauthorized - Smart Wash room system Kidana SWS',
  },
  {
    path: '**',
    loadComponent: () =>
      import('./features/errors/pages/not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
    title: 'Page Not Found - Smart Wash room system Kidana SWS',
  },
];
